module.exports = __webpack_public_path__ + "img/hochmut.f525ecec.png";